<app-breadcrumbs></app-breadcrumbs>
<div 
  *ngIf="fullText" 
  class="tooltip-popup"
  [style.left.px]="tooltipX"
  [style.top.px]="tooltipY">
  {{ fullText }}
</div>
<div class="admin-area pt-5">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-3">
        <div class="admin-area-item">
          <div class="admin-area-left">
            <div class="single-profile-contact">
              <h5>Admin Panel</h5>
              <ul>
                <li *ngIf="canViewUsers">
                  <i class="icofont-users-social"></i>
                  <a [ngClass]="{'is-active': isUsers}" (click)="getAllUsers()">
                    Users
                  </a>
                </li>
                <li><i class="icofont-archive"></i>
                  <a [ngClass]="{'is-active': isMedicalTests}" (click)="getAllLocalProducts()">
                    Medical Tests
                  </a>
                </li>
                <li><i class="icofont-archive"></i>
                  <a [ngClass]="{'is-active': isDrugs}" (click)="getAllDrugs()">
                    Drugs
                  </a>
                </li>
                <li *ngIf="canViewOrders">
                  <i class="icofont-clip-board"></i>
                  <a [ngClass]="{'is-active': isOrders}" (click)="getAllOrders()">
                    Orders
                  </a>
                </li>
                <li *ngIf="isSuperAdmin"><i class="icofont-clip-board"></i>
                  <a [ngClass]="{'is-active': isAllAdmins}" (click)="getAllAdmins()">
                    Permissions
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-9">
        <div class="admin-area-item">
          <div class="admin-area-right">
            <div *ngIf="isMedicalTests && canAddMedicalTest" class="medical-test-links">
              <a routerLink="/add-edit-product" [state]="{ isAddDrug: false }" class="sigma_btn btn-sm mb-3">
                Add <i class="fal fa-plus"></i>
              </a>
              <a (click)="onEditConsultationAmount()" class="sigma_btn btn-sm mb-3">
                Edit Consultation Price<i class="fal fa-plus"></i>
              </a>
            </div>
            <!-- TODO: add 'canAddDrug' when it is available in the backend -->
            <div *ngIf="isDrugs" class="medical-test-links">
              <a routerLink="/add-edit-product" [state]="{ isAddDrug: true }" class="sigma_btn btn-sm mb-3">
                Add<i class="fal fa-plus"></i>
              </a>
            </div>
            <div *ngIf="isAllAdmins && isSuperAdmin">
              <a routerLink="/permissions" class="sigma_btn btn-sm mb-3">
                Configure Scope
                <i class="fal fa-plus"></i>
              </a>
            </div>
            <div class="admin-panel" id="admin-panel">
              <app-table
                *ngIf="isUsers && canViewUsers"
                [tableTitle]="'Users'"
                [tableColumnTitles]="titles"
                [tableData]="tableData"
              >
                <div tablebody>
                  <ng-template let-data let-i="index" #table>
                    <td>{{i + 1}}</td>
                    <td>{{data['firstname']}}</td>
                    <td>{{data['lastname']}}</td>
                    <td>{{data['gender']}}</td>
                    <td class="ellipsis">
                      <i class="fal fa-info-circle info-icon" (click)="showFullText($event, data['address'])"></i>
                      <span class="truncate">{{ data['address'] }}</span>
                    </td>
                    <td *ngIf="isSuperAdmin" class="d-flex justify-content-center align-items-center">
                      <i 
                        class="fal fa-trash" 
                        *ngIf="data.id !== loggedInUser.id"
                        (click)="onDeleteUser(data)"
                        [ngClass]="canViewUsers ? '': 'is-inactive'"
                      ></i>
                    </td>
                  </ng-template>
                </div>
              </app-table>

              <app-table
                *ngIf="isMedicalTests"
                [tableTitle]="'Medical Tests'"
                [tableColumnTitles]="titles"
                [tableData]="tableData"
              >
                <div tablebody> 
                  <ng-template let-data let-i="index" #table>
                    <td>{{i + 1}}</td>
                    <td>{{data['name']}}</td>
                    <td>{{data['category']}}</td>
                    <td>{{data['price']}}</td>
                    <td  *ngIf="isSuperAdmin">{{data['partner_price']}}</td>
                    <td>
                      <i 
                        class="fal fa-edit" 
                        (click)="onEditProduct(data)" 
                        [ngClass]="canEditMedicalTests ? '': 'is-inactive'"
                      >
                      </i>
                      <i 
                        class="fal fa-trash" 
                        (click)="onDeleteProduct(data)"
                        [ngClass]="canEditMedicalTests ? '': 'is-inactive'"
                      ></i>
                    </td>
                  </ng-template>
                </div>
              </app-table>

              <app-table
                *ngIf="isDrugs"
                [tableTitle]="'Drugs'"
                [tableColumnTitles]="titles"
                [tableData]="tableData"
              >
                <div tablebody> 
                  <ng-template let-data let-i="index" #table>
                    <td>{{i + 1}}</td>
                    <td>{{data['name']}}</td>
                    <td>{{data['category']}}</td>
                    <td>
                      <ng-container >
                        <ul class="drug-quantity-list">
                          <li *ngFor="let quantity of data.quantity_types; let i = index">
                            <span class="drug-quantity-span">{{ i + 1 }}. {{ quantity.name }}</span>
                          </li>
                        </ul>
                      </ng-container>
                    </td>
                    <td>
                      <ng-container>
                        <ul class="drug-quantity-list">
                          <li *ngFor="let quantity of data.quantity_types; let i = index">
                            <span class="drug-quantity-span">{{ quantity.selling_price }}</span>
                          </li>
                        </ul>
                      </ng-container>
                    </td>
                    <td *ngIf="isSuperAdmin">
                      <ng-container>
                        <ul class="drug-quantity-list">
                          <li *ngFor="let quantity of data.quantity_types; let i = index">
                            <span class="drug-quantity-span">{{ quantity.partner_price }}</span>
                          </li>
                        </ul>
                      </ng-container>
                    </td>
                    <td class="availability">
                      <ng-container>
                        <ul class="drug-quantity-list">
                          <li *ngFor="let quantity of data.quantity_types; let i = index">
                            <span class="drug-quantity-span" [ngClass]="{'out-of-stock': quantity['is_in_stock'] === 0 }">
                              {{ quantity['is_in_stock'] === 1 ? 'In stock' : 'Out of stock' }}
                            </span>
                          </li>
                        </ul>
                      </ng-container>
                    </td>
                    <td>
                      <!-- TODO: add 'canEditDrugs' when it is available in the backend -->
                      <i 
                        class="fal fa-edit" 
                        (click)="onEditProduct(data)" 
                      >
                      </i>
                       <!-- TODO: add 'canEditDrugs' when it is available in the backend -->
                      <i 
                        class="fal fa-trash" 
                        (click)="onDeleteProduct(data)"
                      ></i>
                    </td>
                  </ng-template>
                </div>
              </app-table>

              <app-table
                *ngIf="isOrders && canViewOrders"
                [tableTitle]="'Orders'"
                [tableColumnTitles]="titles"
                [tableData]="tableData"
              >
                <div tablebody>
                  <ng-template let-data let-i="index" #table>
                    <td>{{i + 1}}</td>
                    <td class="ellipsis">
                      <ul>
                        <ng-container *ngIf="data && data.medical_tests?.length > 0">
                          <li *ngFor="let test of data.medical_tests; let i = index" class="ellipsis">
                            <i class="fal fa-info-circle info-icon" (click)="showFullText($event, test.name)"></i>
                            <span class="truncate">{{ i + 1 + '. ' + test.name }}</span>
                          </li>
                        </ng-container>
                        <ng-container *ngIf="data && data.drugs?.length > 0">
                          <li *ngFor="let drug of data.drugs; let i = index" class="ellipsis">
                            <i class="fal fa-info-circle info-icon" (click)="showFullText($event, drug.name)"></i>
                            <span class="truncate">{{ i + 1 + '. ' + drug.name }}</span>
                          </li>
                        </ng-container>
                        <li *ngIf="data.medical_consultation" class="ellipsis">
                          <i class="fal fa-info-circle info-icon" (click)="showFullText($event, 'Medical Consultation')"></i>
                          <span class="truncate">
                            {{ (data.medical_tests?.length || 0) + 1 + '. ' }} Medical Consultation
                          </span>
                        </li>
                      </ul>
                    </td>
                    <td>{{ data.order_number }}</td>
                    <td>{{ data.fullName }}</td>
                    <td class="ellipsis">
                      <i class="fal fa-info-circle info-icon" (click)="showFullText($event, data['telephone'])"></i>
                      <span class="truncate">{{ data['telephone'] }}</span>
                    </td>
                    <td class="ellipsis">
                      <i class="fal fa-info-circle info-icon" (click)="showFullText($event, data['location'])"></i>
                      <span class="truncate">{{ data['location'] }}</span>
                    </td>                    
                    <td [ngClass]="{
                      'confirmation': data['status'] === 'Order Confirmation',
                      'collection': data['status'] === 'Sample Collection',
                      'processing': data['status'] === 'Sample Processing',
                      'results': data['status'] === 'Results Processing',
                      'complete': data['status'] === 'Order Complete'
                    }">
                      {{data['status']}}
                    </td>
                    <td>
                      <i 
                        class="fal fa-edit" 
                        (click)="onEditOrder(data)"
                        [ngClass]="canEditOrders ? '': 'is-inactive'"
                      ></i>
                      <i 
                        class="fal fa-trash" 
                        (click)="onDeleteOrder(data)"
                        [ngClass]="canEditOrders ? '': 'is-inactive'"
                      ></i>
                    </td>
                  </ng-template>
                </div>
              </app-table>
              <app-table
                *ngIf="isAllAdmins && isSuperAdmin"
                [tableTitle]="'Admins'"
                [tableColumnTitles]="titles"
                [tableData]="tableData"
              >
                <div tablebody>
                  <ng-template let-data let-i="index" #table>
                    <td>{{i + 1}}</td>
                    <td>{{data['firstname'] + ' ' + data['lastname']}}</td>
                    <td>{{roleLabels[data.role?.name]}}</td>
                    <td>
                      <button class="sigma_btn btn-sm view-btn mt-2 mb-2" (click)="editRole(data)">Edit</button>
                    </td>
                    <td [innerHTML]="rolePermissions[data.role?.name]"></td>
                  </ng-template>
                </div>
              </app-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
